import React from "react";
import { IntlProvider, FormattedMessage } from "react-intl";
import BeatLoader from "react-spinners/BeatLoader";

import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";

const messages = {
    en: messages_en,
    fr: messages_fr,
};

const DeleteModal = ({
    handleDelete,
    setShowDeleteModal,
    locale,
    isLoading,
}) => {
    return (
        <IntlProvider
            locale={locale}
            defaultLocale="en"
            messages={messages[locale]}
        >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-end md:items-center z-50">
                <div className="w-full md:w-2/5 h-1/3 md:h-1/4 bg-white rounded-lg drop-shadow-lg text-black px-10 py-8 flex flex-col gap-4 justify-between">
                    <div className="flex flex-col gap-4">
                        <div className="text-xl font-bold text-left">
                            <FormattedMessage id="deleteModal.deleteMeeting" />
                        </div>
                        <div className="text-gray-600 text-base text-left">
                            <FormattedMessage id="deleteModal.confirm" />
                        </div>
                    </div>
                    <div className="flex gap-3 justify-end text-md">
                        <button
                            onClick={() => setShowDeleteModal()}
                            className="text-gray bg-gray-200 px-4 py-2 rounded-full disabled:bg-gray-200 hover:bg-black hover:text-white hover:disabled:text-black w-1/3 md:w-1/4"
                        >
                            <FormattedMessage id="deleteModal.cancel" />
                        </button>
                        <button
                            onClick={handleDelete}
                            disabled={isLoading}
                            className="text-white bg-rose-500 px-4 py-2 rounded-full w-1/3 md:w-1/4"
                        >
                            {isLoading ? (
                                <BeatLoader
                                    color="#ffffff"
                                    // loading={loading}
                                    // cssOverride={override}
                                    size={7}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            ) : (
                                <FormattedMessage id="deleteModal.delete" />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </IntlProvider>
    );
};

export default DeleteModal;
